import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  ConfigLoader,
  DefaultConfigLoader,
  DefaultSettingsService,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

export const commonsProvidersFrom = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
];

export const commonsProviders = [
  { provide: ConfigLoader, useClass: DefaultConfigLoader },
  { provide: SettingsService, useClass: DefaultSettingsService },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
];
